import { render, staticRenderFns } from "./Tvf_prefills.vue?vue&type=template&id=1c5c2814&scoped=true&"
import script from "./Tvf_prefills.vue?vue&type=script&lang=js&"
export * from "./Tvf_prefills.vue?vue&type=script&lang=js&"
import style0 from "./Tvf_prefills.vue?vue&type=style&index=0&id=1c5c2814&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5c2814",
  null
  
)

export default component.exports